import React from 'react';
import { useNotify } from 'react-admin';
import { Filter } from '@/components/Global';
import { getPortsList, getVesselSchedule, SaveApiResMessage } from '@/actions';
import styles from './styles';
import Pagination from '@/components/pagination';
import Add from './Add';
import ListAdmin from './ListAdmin';
import LoadingV2 from '@/components/Loading';

export default (props) => {
  const cls = styles();
  const notify = useNotify();
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [1],
  });
  const [loading, setLoading] = React.useState(true);
  const [DATATable, setDataTable] = React.useState({});
  const [PortsList, setPortsList] = React.useState({});

  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
  });
  const createArrayFromNumbers = (number) => {
    let numberArray = [];
    for (let i = 1; i <= number; i++) {
      numberArray.push(i);
    }

    return numberArray;
  };

  const getGateScheduleList = () => {
    setLoading(true);
    getVesselSchedule()
      .then((res) => {
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        console.log('res', res);

        setPagination((prev) => {
          return {
            ...prev,
            pages: createArrayFromNumbers(
              Math.ceil(res.data.vessels.total / res.data.vessels.per_page)
            ),
          };
        });
        // console.log('pagination', pages);
        setDataTable(res.data.vessels);
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getPortsListFanc = () => {
    setLoading(true);
    getPortsList()
      .then((res) => {
        setPortsList(Object.values(res.data.ports).map((ports) => ports));
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  React.useEffect(() => {
    // getPortsListFanc();
    getGateScheduleList();
  }, [pagination.currentPage]);
  return (
    <div id="inventoryEmpty" className={cls.content}>
      <div className={cls.cardHeader}>
        <span className={cls.title}>Vessel Schedule Setting</span>
        <span>
          <span className={cls.title}>Export</span>
          <span
            className={cls.titleBlue}
            // onClick={handleExport}
          >
            XLSX
          </span>
        </span>
      </div>
      {/* <Add
        notify={notify}
        DATATable={DATATable}
        setData={(res) => {
          setFilter({ ...filter, DATATable });
        }}
      /> */}
      {/* <Filter
        title="Gate Schedule"
        filter={filter}
        setFilter={setFilter}
        DATA={DATATable}>
        <span className={cls.title}>Export</span>
        <span
          className={cls.titleBlue}
          // onClick={handleExport}
        >
          XLSX
        </span>
      </Filter>
 */}
      {loading ? (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      ) : (
        <ListAdmin
          DATA={DATATable}
          VesselsList={DATATable.data}
          PortsList={PortsList}
        />
      )}
      {/* <Pagination pagination={pagination} setPagination={setPagination} /> */}
    </div>
  );
};
